// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-container__uploaded-history-item {
  display: flex;
  justify-content: flex-end;
  align-items: center; }

.upload-container__uploaded-history-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px; }

.upload-container__uploaded-history .icon-remove {
  color: red;
  font-size: 20px;
  padding: 6px 0 6px 10px;
  cursor: pointer;
  display: flex; }

.upload-container__uploaded-history .react-bootstrap-table table tr td,
.upload-container__uploaded-history .react-bootstrap-table table tr th {
  word-break: break-word; }

.upload-container__uploaded-history .react-bootstrap-table thead > tr > th {
  background-color: #ccc; }

.upload-container__uploaded-history .react-bootstrap-table thead > tr > th:first-child {
  width: 72%; }

.upload-container__uploaded-history .react-bootstrap-table thead > tr > th:nth-child(2) {
  width: 18%; }

.upload-container__uploaded-history .react-bootstrap-table thead > tr > th:last-child {
  width: 10%;
  text-align: center; }

.upload-container__uploaded-history .react-bootstrap-table-pagination .col-md-6.col-xs-6.col-sm-6.col-lg-6 {
  padding-right: 0;
  padding-left: 0; }

.upload-container__uploaded-history .react-bootstrap-table-pagination .react-bs-table-sizePerPage-dropdown .btn-secondary {
  background-color: #157347; }

.upload-container__uploaded-history .react-bootstrap-table-pagination .react-bootstrap-table-pagination-list .page-link {
  color: #000; }

.upload-container__uploaded-history .react-bootstrap-table-pagination .react-bootstrap-table-pagination-list .active > .page-link {
  background-color: #157347;
  border-color: #157347;
  color: #fff; }

.upload-container__uploaded-history .react-bootstrap-table-pagination .react-bootstrap-table-pagination-list .react-bootstrap-table-page-btns-ul {
  justify-content: flex-end; }

.stage {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 22px;
  flex-wrap: wrap; }

.dot-flashing {
  position: relative;
  margin-bottom: 4px;
  width: 6px;
  height: 6px;
  border-radius: 5px;
  background-color: #000000;
  color: #000000;
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s; }

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0; }

.dot-flashing::before {
  left: -12px;
  width: 6px;
  height: 6px;
  border-radius: 5px;
  background-color: #000000;
  color: #000000;
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s; }

.dot-flashing::after {
  left: 12px;
  width: 6px;
  height: 6px;
  border-radius: 5px;
  background-color: #000000;
  color: #000000;
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s; }

@keyframes dot-flashing {
  0% {
    background-color: #000000; }
  50%,
  100% {
    background-color: rgba(59, 59, 61, 0.2); } }
`, "",{"version":3,"sources":["webpack://./src/features/UploadFiles/Components/UploadHistory/index.scss"],"names":[],"mappings":"AACE;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB,EAAA;;AAErB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAA;;AAVvB;EAaI,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,aAAa,EAAA;;AAjBjB;;EAsBM,sBAAsB,EAAA;;AAtB5B;EA0BQ,sBAAsB,EAAA;;AA1B9B;EA6BQ,UAAU,EAAA;;AA7BlB;EAgCQ,UAAU,EAAA;;AAhClB;EAmCQ,UAAU;EACV,kBAAkB,EAAA;;AApC1B;EA0CM,gBAAgB;EAChB,eAAe,EAAA;;AA3CrB;EA+CQ,yBAAyB,EAAA;;AA/CjC;EAoDQ,WAAW,EAAA;;AApDnB;EAuDQ,yBAAyB;EACzB,qBAAqB;EACrB,WAAW,EAAA;;AAzDnB;EA4DQ,yBAAyB,EAAA;;AAMjC;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,SAAS;EACT,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oDAAoD;EACpD,qBAAqB,EAAA;;AAEvB;;EAEE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,MAAM,EAAA;;AAER;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,6CAA6C;EAC7C,mBAAmB,EAAA;;AAErB;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,6CAA6C;EAC7C,mBAAmB,EAAA;;AAGrB;EACE;IACE,yBAAyB,EAAA;EAE3B;;IAEE,uCAAuC,EAAA,EAAA","sourcesContent":[".upload-container__uploaded-history {\r\n  &-item {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n  }\r\n  &-title {\r\n    text-align: center;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    margin-bottom: 12px;\r\n  }\r\n  .icon-remove {\r\n    color: red;\r\n    font-size: 20px;\r\n    padding: 6px 0 6px 10px;\r\n    cursor: pointer;\r\n    display: flex;\r\n  }\r\n  .react-bootstrap-table {\r\n    table tr td,\r\n    table tr th {\r\n      word-break: break-word;\r\n    }\r\n    thead > tr {\r\n      & > th {\r\n        background-color: #ccc;\r\n      }\r\n      & > th:first-child {\r\n        width: 72%;\r\n      }\r\n      & > th:nth-child(2) {\r\n        width: 18%;\r\n      }\r\n      & > th:last-child {\r\n        width: 10%;\r\n        text-align: center;\r\n      }\r\n    }\r\n  }\r\n  .react-bootstrap-table-pagination {\r\n    .col-md-6.col-xs-6.col-sm-6.col-lg-6 {\r\n      padding-right: 0;\r\n      padding-left: 0;\r\n    }\r\n    .react-bs-table-sizePerPage-dropdown {\r\n      .btn-secondary {\r\n        background-color: #157347;\r\n      }\r\n    }\r\n    .react-bootstrap-table-pagination-list {\r\n      .page-link {\r\n        color: #000;\r\n      }\r\n      .active > .page-link {\r\n        background-color: #157347;\r\n        border-color: #157347;\r\n        color: #fff;\r\n      }\r\n      .react-bootstrap-table-page-btns-ul {\r\n        justify-content: flex-end;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.stage {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: flex-start;\r\n  gap: 22px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.dot-flashing {\r\n  position: relative;\r\n  margin-bottom: 4px;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 5px;\r\n  background-color: #000000;\r\n  color: #000000;\r\n  animation: dot-flashing 1s infinite linear alternate;\r\n  animation-delay: 0.5s;\r\n}\r\n.dot-flashing::before,\r\n.dot-flashing::after {\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n.dot-flashing::before {\r\n  left: -12px;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 5px;\r\n  background-color: #000000;\r\n  color: #000000;\r\n  animation: dot-flashing 1s infinite alternate;\r\n  animation-delay: 0s;\r\n}\r\n.dot-flashing::after {\r\n  left: 12px;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 5px;\r\n  background-color: #000000;\r\n  color: #000000;\r\n  animation: dot-flashing 1s infinite alternate;\r\n  animation-delay: 1s;\r\n}\r\n\r\n@keyframes dot-flashing {\r\n  0% {\r\n    background-color: #000000;\r\n  }\r\n  50%,\r\n  100% {\r\n    background-color: rgba(59, 59, 61, 0.2);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
